import { fromJS } from 'immutable'
import { RxConversationAPI } from '@driftt/dapper'

export const api = {
  fetchTargets() {
    return RxConversationAPI.get(`/targets`)
      .checkStatus()
      .retryWithBackoff()
      .map(fromJS)
  },
  createTarget(target) {
    return RxConversationAPI.post(`/targets`, target)
      .checkStatus()
      .retryWithBackoff()
      .map(fromJS)
  },
  patchTarget(operations, id) {
    return RxConversationAPI.patch(`/targets/${id}`, operations)
      .checkStatus()
      .retryWithBackoff()
      .map(fromJS)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/targeting/api.js